import type React from 'react';

import { usePasswordForm } from '@/hooks/registration/usePasswordForm';
import PasswordFormView from '@/components/organism/Registration/PasswordForm/PasswordForm.view';

export function PasswordForm(): React.JSX.Element {
  const { state, handlers } = usePasswordForm();

  return (
    <PasswordFormView
      password={state.password}
      confirmPassword={state.confirmPassword}
      showPassword={state.showPassword}
      showConfirmPassword={state.showConfirmPassword}
      passwordError={state.passwordError}
      globalError={state.globalError}
      stage={state.stage}
      isSubmitting={state.isSubmitting}
      isContinueDisabled={state.isContinueDisabled}
      onPasswordChange={handlers.handlePasswordChange}
      onConfirmPasswordChange={handlers.handleConfirmPasswordChange}
      onTogglePassword={handlers.handleTogglePassword}
      onToggleConfirmPassword={handlers.handleToggleConfirmPassword}
      onSubmit={handlers.handleSubmit}
    />
  );
}

PasswordForm.displayName = 'PasswordForm';

export default PasswordForm;
